export default {
  tablet: 768,
  laptop: 1024,
  notebook: 1366,
  desktop: 1536,
  //   sm: 576,
  //   md: 768,
  //   lg: 992,
  //   xl: 1200,
  //   xxl: 1400,
};
